import { useEffect, useState } from 'react'

import { FontAwesomeIcon as FontA, FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import Icon from '@ant-design/icons'
import { GoogleMap, Polygon } from '@react-google-maps/api'
import { Badge, Button, Card, Form, message, Modal, Select, Space, Switch, Table } from 'antd'
import { Notification } from '../../../Components/notification'

import {
  delPropriedade,
  getPropriedade,
  PropriedadeItens,
  putPropriedade,
} from '../../../services/Propriedades'

import FomrPropriedade from '../../../Components/propriedade'

import { ColumnsType } from 'antd/lib/table'
import { pagination } from '../../../Components/Default'
import { IconAlert } from '../../../Components/iconsAlert'
import ViewPage from '../../../Components/ViewPage'
import { useLogic } from '../../../context/useLogic'
import { centerMap, tryError } from '../../../services/Afins'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { getSafra, SafraItens } from '../../../services/Safra'
import { getTalhao, TalhaoItens } from '../../../services/Talhao'
import { getTalhaoCultivavel, TalhaoCultivaveisItens } from '../../../services/TalhaoSafra'
import { Container, ContainerMap } from './styled'

interface TypesMapa {
  zoom: number
  center: {
    lat: number
    lng: number
  }
  style?: { [key: string]: string }
}

interface TypesVisuPropri {
  name?: string
  cod?: number
  cor?: string
  areaPropriedade?: number
  talhoes?: TalhaoItens[]
}

const Propriedades = () => {
  const [form] = Form.useForm()

  const { codCliente } = useLogic()

  const [dataPropriedade, setDataPropriedade] = useState([])
  const [dataPropriedadeStatus, setDataPropriedadeStatus] = useState([])
  const [tempPolygon, setTempPolygon] = useState<any>()

  const [talhoesCultivaveis, setTalhoesCultivaveis] = useState<TalhaoCultivaveisItens[]>([])

  const [polygon, setPolygon] = useState<google.maps.Polygon>()
  const [map, setMap] = useState<google.maps.Map>()

  const [loadingTable, setLoadingTable] = useState(false)
  const [visibleForm, setVisibleForm] = useState<boolean>(false)
  const [udatePropriedade, setUpdatePropriedade] = useState(0)
  const [codPropriedade, setCodPropriedade] = useState(0)

  const [dataVisuPropridades, setDataVisuPropridades] = useState<TypesVisuPropri[]>([])

  const infoWindow = new window.google.maps.InfoWindow()

  const [visualizarPropriedade, setVisualizarPropriedade] = useState(false)
  const [visualizarPropriedadesCliente, setVisualizarPropriedadesCliente] = useState(false)

  const [dataPolygon, setDataPolygon] = useState([])

  const [loadingStatus, setLoadingStatus] = useState(null)

  const [hideStatus, setHideStatus] = useState(false)

  const [dataSafra, setDataSafra] = useState<SafraItens[]>([])

  const [nomePropriedade, setNomePropriedade] = useState<string>()

  const [loadingVisuPropriedades, setLoadingVisuPropriedades] = useState(false)

  const [permissions, setPermissions] = useState<ItensPerUserLogged>({} as ItensPerUserLogged)

  const [dadosProp, setDadosProp] = useState([])


  const [propsMap, setPropsMapa] = useState<TypesMapa>({
    zoom: 2,
    center: {
      lat: 0,
      lng: 0,
    },
    style: { width: '100%', height: '78vh' },
  })

  const handleClickVisuPropriedade = (data) => {
    setVisibleForm(true)
    setUpdatePropriedade(data)
  }

  const handleClickPolygon = (
    e: google.maps.PolyMouseEvent,
    index,
    cliente = null,
    indexT = null
  ) => {
    if (tempPolygon) {
      tempPolygon.close()
    }
    const position = e.latLng.toJSON()
    let content
    if (cliente === null) {
      const talhao = talhoesCultivaveis.find((data, i) => i === index)

      content = `<h5><b>Nome</b>: ${talhao.nome} <br /> <b>Área</b>: ${talhao.area}/ha <br /> `

      const dados = JSON.parse(JSON.stringify(dataPolygon))

      dados.forEach((data, i) => {
        if (i === index) {
          data.cor = 'orange'
        } else {
          data.cor = form.getFieldValue('safra') !== 0 ? 'yellow' : 'cyan'
        }
      })

      setDataPolygon(dados)
    } else {
      const listTalhoesVis = [...dataVisuPropridades]

      listTalhoesVis.forEach((info, i) => {
        info.talhoes.forEach((record, ii) => {
          if (indexT === ii && index === i) {
            record.cor = 'orange'
          } else {
            record.cor = 'cyan'
          }
        })
      })
      content = `<h5>
                    <b>Propriedade</b>: ${cliente.name} <br /> 
                    <b>Área da propriedade</b>: ${cliente.areaPropriedade}/ha <br /> 
                    <br />
                    <b>Nome do talhão</b>: ${cliente.nome_talhao} <br />
                    <b>Área do talhão</b>: ${cliente.area}/ha <br />`
      setDataVisuPropridades([...listTalhoesVis])
    }
    // <b>Lat:</b> ${position.lat.toFixed(6)} <b>Lng:</b> ${position.lng.toFixed(6)}</h5>

    infoWindow.setContent(content)
    infoWindow.setPosition(position)
    infoWindow.open({
      anchor: polygon,
      map,
      shouldFocus: true,
    })
    setTempPolygon(infoWindow)
  }


  /*  Function que tem uma chamada no btn de delete, onde puxa os dados da propriedade para fazer a exclusão,
      btn que tambem chama uma modal de confirmação.




  */

  const handleTrashPropriedade = async (data, itemProp, record) => {
    const codCli = localStorage.getItem('cod-cliente')

    /*  const responsePro = await getPropriedade(data)
 
     const nomePro = responsePro.data.itens[0].nome */
    const { nome } = itemProp


    Modal.confirm({
      title: 'Excluir',
      icon: <IconAlert type='confirm' size={6} />,
      content: `Deseja realmente remover a Propriedade ${nome}?`,
      okText: 'Confirmar',
      cancelText: 'Cancelar',
      cancelButtonProps: {
        type: 'primary',
        danger: true,
      },
      onOk: async () => {
        try {
          const responseDel = await delPropriedade(data, codCli, itemProp)

          if (responseDel.status === 200) {
            Notification({
              message: 'Propriedade Excluida',
              type: 'success',
            })

            listarPropriedades('')
          }
        } catch (error) {
          if (error.response) {
            const { data } = error.response
            Notification({
              type: 'error',
              duration: 99999,
              message: 'Erro',
              descricao: data.error,
            })
          }
        }
      },
    })
  }

  const handleClickVisualizarTodasPropriedades = async () => {
    let talhoes = []

    setLoadingVisuPropriedades(true)
    for (let i = 0; i < dataPropriedade.length; i += 1) {
      const propri = dataPropriedade[i]

      const resp = await getTalhao(propri.cod, '')

      if (resp.data.itens.length > 0) {
        resp.data.itens.forEach((data) => {
          data.cor = 'cyan'
        })
        talhoes = [
          ...talhoes,
          {
            cod: propri.cod,
            areaPropriedade: propri.area,
            name: propri.nome,
            talhoes: resp.data.itens,
          },
        ]
      }
    }
    
    let centeRs: google.maps.LatLngLiteral[] = []
    if (talhoes.length > 0) {
      talhoes[0].talhoes[0].kml.coordenadas.forEach((data) => {
        centeRs = [...centeRs, { lng: data.longitude, lat: data.latitude }]

        return centeRs
      })

      const center: google.maps.LatLngLiteral = centerMap(centeRs).toJSON()

      setPropsMapa({ center, zoom: 11 })
    } else {
      Notification({ message: 'Cliente não possui talhões', type: 'info' })
      setLoadingVisuPropriedades(false)
      return
    }

    setDataVisuPropridades(talhoes)
    setVisualizarPropriedadesCliente(true)
    setLoadingVisuPropriedades(false)
  }

  const handleVisibleForm = () => {
    setVisibleForm(true)
    setUpdatePropriedade(0)
  }

  /* Visualizar propriedade */
  const handleVisualizarPropri = async (data, info, cod) => {
    message.loading('Carregando...', 99999)
    const responsePro = await getPropriedade(data)
    const response =
      info.key === '0'
        ? await getTalhao(cod === '' ? codPropriedade : cod, '')
        : await getTalhaoCultivavel({ codPropriedade, codSafra: info.value })

    const dados = response.data.itens

    setTalhoesCultivaveis(dados)

    
    if (dados.length > 0) {
      let talhoes = []

      for (let i = 0; i < dados.length; i += 1) {
        const element = dados[i]
        let temp = []
        for (let ii = 0; ii < element.kml.coordenadas.length; ii += 1) {
          const coord = element.kml.coordenadas[ii]

          element.kml.coordenadas[ii].lng = coord.longitude
          element.kml.coordenadas[ii].lat = coord.latitude

          temp = [...temp, { lat: parseFloat(coord.lat), lng: parseFloat(coord.lng) }]
        }
        talhoes = [...talhoes, temp]
      }

      const centro = centerMap(talhoes[0])

      setPropsMapa({
        center: {
          lat: centro.lat(),
          lng: centro.lng(),
        },
        zoom: 11,
      })
      setDataPolygon(talhoes)
      setVisualizarPropriedade(true)
      message.destroy()
    } else {
      Notification({
        message: 'Propriedade não possui talhões cadastrados',
        type: 'info',
      })
      setDataPolygon([])
      message.destroy()
    }
  }

  /* Lista as propriedades */
  const listarPropriedades = async (cod, loading = false) => {
    if (loading) {
      setLoadingTable(true)
    }
    const response = await getPropriedade(cod)
    const dados = response.data.itens
    


    
    setDataPropriedade(dados)
    setNomePropriedade(dados[0]?.nome)

    setDataPropriedadeStatus(dados.filter((rec) => rec.status !== 0))
    setLoadingTable(false)
  }


  const listSafra = async () => {
    const resp = await getSafra({ pagination: 15, order: 'data_inicio' })

    setDataSafra(resp.data.itens)
  }

  const handleChangeSwitchStatus = async (cod, index, status: number) => {
    try {
      setLoadingStatus(index)
      await putPropriedade(codCliente, cod, {
        status: status === 1 ? 0 : 1,
      })

      listarPropriedades('')

      setLoadingStatus(null)
    } catch (error) {
      tryError(error)
      setLoadingStatus(null)
    }
  }

  const handleChangeSwitchOcultarInativo = (e) => {
    setHideStatus(e)
  }

  const onLoadMap = (e: google.maps.Map) => {
    setMap(e)
  }

  const onLoadPolygon = (e: google.maps.Polygon) => {
    setPolygon(e)
  }
  /* useEffect que fica observando a hora que o componente é montado, quando for montado ele vai reagir 
  fazendo com que seja listado as propriedade e as safras
  
  */
  useEffect(() => {
    listarPropriedades('', true)
    listSafra()

    form.setFieldsValue({
      safra: 0,
    })
  }, [])

  const colums: ColumnsType<PropriedadeItens> = [
    {
      title: (
        <Space style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
          Ocultar inativos{' '}
          <Switch
            onChange={handleChangeSwitchOcultarInativo}
            size='default'
            checkedChildren='Sim'
            unCheckedChildren='Não'
          />
        </Space>
      ),
      align: 'left',
      children: [
        {
          title: 'Ativo',
          dataIndex: 'status',
          width: 70,
          align: 'center',
          key: 'status',
          render: (status, record, i) => {
            return (
              <Switch
                loading={loadingStatus === i}
                size='small'
                onChange={() => handleChangeSwitchStatus(record.cod, i, status)}
                checked={status === 1}
                checkedChildren='Sim'
                unCheckedChildren='Não'
              />
            )
          },
        },
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Área/ha',
          dataIndex: 'area',
          key: 'area',
          render: (data) => {
            return <>{data.replace('.', ',')}</>
          },
        },
        {
          title: 'Município/UF',
          dataIndex: 'cidade',
          key: 'cidade',
          render: (data) => {
            return (
              <p>
                {data[0].nome}/{data[0].uf}
              </p>
            )
          },
        },
        {
          title: 'Ações',
          dataIndex: 'cod',
          width: '135px',
          key: 'acao',
          render: (data, record: any, itemProp) => (
            <Space>
              <Button
                shape='circle'
                onClick={() => handleClickVisuPropriedade(data)}
                icon={<FontA icon={solid('pen')} />}
                hidden={permissions?.alteracao === 0 && permissions?.acesso === 0}
                size='middle'
              />
              <Button
                shape='circle'
                onClick={() => {
                  setNomePropriedade(record.nome)
                  setCodPropriedade(record.cod)
                  form.setFieldsValue({ safra: 0 })
                  handleVisualizarPropri(
                    data,
                    {
                      key: '0',
                      value: data,
                      children: 'Talhões da propriedade',
                    },
                    record.cod
                  )
                }}
                icon={<FontA icon={solid('map-marked')} />}
                size='middle'
              />
              <Button
                hidden={permissions?.exclusao === 0}
                shape='circle'
                onClick={() => handleTrashPropriedade(data, record, itemProp)}
                className='trash-button'
                type='primary'
                icon={<FontA icon={solid('trash')} />}
                size='middle'
              />
            </Space>
          ),
        },
      ],
    },
  ]

  return (
    <Container>
      <ViewPage
        rotina={25}
        onPermission={setPermissions}
        title='Propriedades'
        btnClick={handleVisibleForm}
        btnsExta={
          <Button
            icon={<Icon component={() => <FontA icon={solid('map-marked')} />} />}
            loading={loadingVisuPropriedades}
            onClick={handleClickVisualizarTodasPropriedades}
            type='primary'
          >
            Visualizar todas propriedades
          </Button>
        }
        content={
          <FomrPropriedade
            onClose={setVisibleForm}
            visible={visibleForm}
            update={udatePropriedade}
            setUpdate={setUpdatePropriedade}
            refresh={listarPropriedades}
            permissions={permissions}
          />
        }
      >
        <Table
          onRow={(record: any) => {
            return {
              onDoubleClick: () => {
                handleClickVisuPropriedade(record.cod)
              },
            }
          }}
          pagination={pagination}
          size='small'
          bordered
          loading={loadingTable}
          dataSource={hideStatus ? dataPropriedadeStatus : dataPropriedade}
          scroll={{ y: 'calc(90vh - 310px)', x: 'auto' }}
          footer={() => (
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'right',
              }}
            >
              <b>Total geral: {dataPropriedade.length}</b>
            </div>
          )}
          columns={colums}
        />
      </ViewPage>
      <Modal
        open={visualizarPropriedade}
        onCancel={() => setVisualizarPropriedade(false)}
        style={{ top: '10px', minWidth: '97%' }}
        closable={false}
        footer={false}
      >
        <ContainerMap>
          {/* @ts-ignore */}
          <GoogleMap
            onLoad={onLoadMap}
            mapContainerClassName='floating'
            zoom={propsMap.zoom}
            mapContainerStyle={{
              width: '100%',
              height: '93vh',
            }}
            center={propsMap.center}
            options={{
              streetViewControl: false,
              fullscreenControl: false,
              mapTypeControl: false,
              mapTypeId: 'hybrid',
            }}
          >
            {dataPolygon.map((data, i) => {
              const color =
                form.getFieldValue('safra') !== 0
                  ? {
                    fillColor: data.cor ? data.cor : 'yellow',
                    strokeColor: data.cor ? data.cor : 'yellow',
                  }
                  : {
                    fillColor: data.cor ? data.cor : 'cyan',
                    strokeColor: data.cor ? data.cor : 'cyan',
                  }
              return (
                <Polygon
                  paths={data}
                  onClick={(e) => handleClickPolygon(e, i)}
                  onLoad={onLoadPolygon}
                  options={color}
                />
              )
            })}
            <Card
              title={nomePropriedade}
              className='floating-safra'
              size='small'
              extra={<Button size='small' ghost icon={<FontAwesomeIcon icon={solid('close')} />} />}
            >
              <Form form={form} layout='vertical'>
                <Form.Item name='safra' label='Tipo visualização'>
                  <Select onChange={(cod, info) => handleVisualizarPropri(cod, info, '')}>
                    <Select.Option key={0} value={0}>
                      <Badge color='cyan' />
                    </Select.Option>
                    <Select.OptGroup label='Talhões da safra'>
                      {dataSafra.map((data) => (
                        <Select.Option key={data.cod} value={data.cod}>
                          <Badge color='yellow' />
                          {data.nome}
                        </Select.Option>
                      ))}
                    </Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item>
                  <Button
                    type='primary'
                    danger
                    block
                    onClick={() => setVisualizarPropriedade(false)}
                  >
                    Fechar
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </GoogleMap>
        </ContainerMap>
      </Modal>
      <Modal
        open={visualizarPropriedadesCliente}
        onCancel={() => setVisualizarPropriedadesCliente(false)}
        style={{ top: '10px', minWidth: '97%' }}
        closable={false}
        footer={false}
      >
        {/* @ts-ignore */}
        <GoogleMap
          mapContainerClassName='floating'
          zoom={propsMap.zoom}
          mapContainerStyle={{
            width: '100%',
            height: '93vh',
          }}
          center={propsMap.center}
          options={{
            zoomControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            mapTypeId: 'hybrid',
          }}
        >
          {dataVisuPropridades.map((data, index) => {
            let poly = []
            for (let i = 0; i < data.talhoes.length; i += 1) {
              const talhoes = data.talhoes[i]

              let tempCoord: google.maps.LatLng[] = []
              for (let j = 0; j < talhoes.kml.coordenadas.length; j += 1) {
                const coord = talhoes.kml.coordenadas[j]

                tempCoord = [
                  ...tempCoord,
                  new google.maps.LatLng({
                    lat: coord.latitude,
                    lng: coord.longitude,
                  }),
                ]
              }
              poly = [
                ...poly,
                {
                  cod_talhao: talhoes.cod,
                  cor: talhoes.cor,
                  nome_talhao: talhoes.nome,
                  area: talhoes.area,

                  coord: tempCoord,
                },
              ]
            }
            return poly.map((info, ii) => {
              const final = { ...data, ...info }
              return (
                <Polygon
                  onClick={(e) => handleClickPolygon(e, index, final, ii)}
                  onLoad={onLoadPolygon}
                  options={{
                    fillColor: info.cor,
                    strokeColor: info.cor,
                  }}
                  paths={info.coord}
                />
              )
            })
          })}
          <Button
            style={{ position: 'absolute', margin: '5px', bottom: 0, right: 0 }}
            type='primary'
            danger
            size='large'
            onClick={() => setVisualizarPropriedadesCliente(false)}
          >
            Fechar
          </Button>
        </GoogleMap>
      </Modal>
    </Container>
  )
}

export default Propriedades
